import ntkPng from "../assets/images/ntk.png";
import ntkWebp from "../assets/images/ntk.webp";
import mnmPng from "../assets/images/mnm.png";
import mnmWebp from "../assets/images/mnm.webp";
import aiadmkPng from "../assets/images/aiadmk.png";
import aiadmkWebp from "../assets/images/aiadmk.webp";
import dmkPng from "../assets/images/dmk.png";
import dmkWebp from "../assets/images/dmk.webp";

const data = [
  //
  {
    id: 0,
    partyName: "நாம் தமிழர் கட்சி",
    partyLeaderNameThamizh: "செந்தமிழன் சீமான்",
    partyLeaderNameEnglish: "Senthamizhan Seeman",
    partyShortName: "ntk",
    logoWebp: ntkWebp,
    logoPng: ntkPng,
  },
  {
    id: 1,
    partyName: "மக்கள் நீதி மய்யம்",
    partyLeaderNameThamizh: "கமல் ஹாசன்",
    partyLeaderNameEnglish: "	Kamal Haasan",
    partyShortName: "mnm",
    logoWebp: mnmWebp,
    logoPng: mnmPng,
  },
  {
    id: 2,
    partyName: "அஇஅதிமுக",
    partyLeaderNameThamizh: "எடப்பாடி க. பழனிசாமி",
    partyLeaderNameEnglish: "Edappadi K. Palaniswami",
    partyShortName: "admk",
    logoWebp: aiadmkWebp,
    logoPng: aiadmkPng,
  },
  {
    id: 3,
    partyName: "திமுக",
    partyLeaderNameThamizh: "மு.க.ஸ்டாலின்",
    partyLeaderNameEnglish: "	M. K. Stalin",
    partyShortName: "dmk",
    logoWebp: dmkWebp,
    logoPng: dmkPng,
  },
];

export default data;
